<template lang="pug">
  .modal.doNotDesactiveOnClick(ref='modal')
    .modal-dialog
      .modal-content
        .modal-header
          button.close(type="button", data-dismiss="modal", aria-hidden="true") &#215;
          h4.modal-title {{$t("events.importModal.title")}}
        .modal-body
          template(v-if='savingState == null')
            form.form-horizontal(role="form")
              .form-group
                label.col-sm-2(for="inputIcsFile") {{$t('events.importModal.fields.file.label')}} *
                .col-sm-10
                  input#inputIcsFile.form-control(ref="fileInput", type='file', @change='fileInputChanged')
              .form-group
                label.col-sm-2(for="inputName") {{$t('events.importModal.fields.group.label')}} *
                .col-sm-10
                  vue-select-a-group(:selectedGroup.sync="selectedGroup")

          .bigIconMessage(v-if='savingState == "saving"')
            i.fa.fa-refresh.fa-spin.grey
            |  {{$t("globals.sending")}}
          .bigIconMessage(v-if='savingState == "saved"')
            i.fa.fa-check.green
            |  {{$t("globals.saved")}}

          .bigIconMessage(v-if='savingState == "error"')
            i.fa.fa-remove.red
            |  {{$t("globals.error")}}

        .modal-footer(v-if='savingState == null')
          button.btn.btn-default.pull-left(type="button", data-dismiss="modal", @click=' cancel') {{$t('globals.cancel')}}
          a.btn.clickable(@click='toggleFileMode') {{$t("events.importModal.toggleModeBtn")}}
          | &nbsp;
          button.btn.btn-primary(type="button", :class='{disabled: !mustHaveIsComplete}', @click=' importEvents')
            | {{$t('globals.import')}}
</template>
<script>
// TO DO : link with calendar, manage personal groop
import modalsBus from '@/components/shared/ModalsBus'

import $ from 'jquery'

import VueSelectAGroup from '@/components/shared/SelectAGroup'

import {mapGetters} from 'vuex'
import STATUS from '@/utils/status'
import api from '@/utils/api'

export default {
  props: {
    eventsBus: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      savingState: null,
      selectedGroup: null,
      files: null
    }
  },
  components: {
    VueSelectAGroup
  },
  mounted () {
    modalsBus.onOpen((arg) => {
      if (arg === modalsBus.modals.IMPORT_ICS) {
        this.openModal()
      } else {
        this.closeModal()
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
  },
  computed: {
    ...mapGetters('groops', [
      'groops',
      'groopsAreLoaded'
    ]),
    mustHaveIsComplete () {
      return this.selectedGroup !== null && this.files !== null
    }
  },
  methods: {
    openModal () {
      this.initValues()
      $(this.$refs.modal).modal('show')
    },
    closeModal () {
      $(this.$refs.modal).modal('hide')
    },
    toggleFileMode () {
      this.closeModal()
      // ugly code, to manage a bug in Bootstrap => closing this modal, sent hidden.bs.modal to the other modal...
      setTimeout(() => {
        modalsBus.open(modalsBus.modals.CREATE_EVENT)
      }, 20)
    },
    importEvents () {
      if (!this.mustHaveIsComplete) {
        return
      }
      this.savingState = STATUS.SAVING
      const data = new FormData()
      data.append('file', this.files[0])
      data.append('gid', this.selectedGroup.id)
      api.post('/importEvents', data)
        .then(response => {
          this.eventsBus.$emit(this.eventsBus.NEW_EVENTS)
          this.savingState = STATUS.SAVED
          setTimeout(() => {
            this.closeModal()
            this.savingState = null
          }
        , 500)
        }).catch(data => {
          this.savingState = STATUS.ERROR
          return setTimeout(() => {
            this.savingState = null
          }
        , 2000)
        })
    },
    cancel () {
      this.closeModal()
    },
    initValues () {
      this.selectedGroup = null
      this.files = null
    },
    fileInputChanged (e) {
      e.preventDefault()
      this.files = this.$refs.fileInput.files
    }
  }
}
</script>



// WEBPACK FOOTER //
// Events-ImportICSModal.vue?0df2a3ec